import { getThunkActionCreator } from 'redux-thunk-routine';
import { clearStoreRoutine } from 'actions';

export const clearStore = getThunkActionCreator(clearStoreRoutine, async () => {});